import React from "react"
import ReactDOM from "react-dom"
import { App } from "./Components/App"
// import * as Sentry from "@sentry/react"

// Sentry.init({
//   dsn: "https://4386fdb06f8ae3a37d48ed1d947735a6@o101255.ingest.us.sentry.io/4509067195252736",
//   integrations: [Sentry.browserTracingIntegration()],
//   tracesSampleRate: 0.1, // Lowered to reduce noise
//   environment: process.env.NODE_ENV,

//   // Noise reduction tips:
//   ignoreErrors: [
//     "ResizeObserver loop limit exceeded",
//     "Non-Error promise rejection captured",
//     "Network error: Failed to fetch",
//     "Assertion failed. User was not returned",
//   ],
//   denyUrls: [/extensions\//i, /^chrome:\/\//i],
//   beforeSend(event) {
//     // Example: ignore errors from development
//     if (process.env.NODE_ENV === "development") {
//       return null
//     }

//     return event
//   },
// })

ReactDOM.render(<App />, document.getElementById("root"))
